module.exports = __webpack_public_path__ + "static/lexus-bdb97cdfbbce95480098657a23e4ec85.jpg";